// extracted by mini-css-extract-plugin
export default {"container":"vY-z","title":"wY-z","link":"xY-z"};